import * as React from "react";

function IcSystemStatusOkDoneFill12(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 12,
    height = 12,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemStatusOkDoneFill12"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#clip0_4978_6717)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM9.28033 5.03033C9.57322 4.73744 9.57322 4.26256 9.28033 3.96967C8.98744 3.67678 8.51256 3.67678 8.21967 3.96967L5.25 6.93934L3.78033 5.46967C3.48744 5.17678 3.01256 5.17678 2.71967 5.46967C2.42678 5.76256 2.42678 6.23744 2.71967 6.53033L4.71967 8.53033C5.01256 8.82322 5.48744 8.82322 5.78033 8.53033L9.28033 5.03033Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4978_6717">
          <rect width={12} height={12} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IcSystemStatusOkDoneFill12;
